/**
 * API Configuration
 * Uses RELATIVE URLs - works on any domain automatically!
 * 
 * Since frontend and backend are on the same domain (Kubernetes ingress),
 * we can use relative URLs which automatically work on:
 * - responsive-lexy.preview.emergentagent.com
 * - norsk-lexy.preview.emergentagent.com  
 * - Any other deployment domain
 */

// Simple relative URL - no domain needed!
export const API_URL = '/api';

export const getApiUrl = () => API_URL;
